<template lang="pug">
k-main.admin-content
  template( #title )
    .title
      h1.title {{ title }}
      k-actions.header-actions( :actions='actions' :icons='icons' )
  .main-content( v-if='post.sections' v-bar )
    .inner
      k-objects(
        v-for='section in sections'
        :key='section.name'
        v-bind='section'
        :icons='icons'        
      )
  .main-content( v-else )
    k-objects( v-bind='post' :icons='icons' inline )
  k-actions.footer-actions(
    :actions='actions'
    :icons='icons'
    type='icon-text'
  )
</template>

<script lang="js">
import { mapState, mapActions } from 'vuex'
import KActions from '@/blocks/k-actions'
import KMain from '@/blocks/k-main'
import KObjects from '@/blocks/k-objects'
import icons from '@/icons'

export default {
  name: 'AdminContentPage',
  mixins: [],
  components: {
    KActions,
    KMain,
    KObjects,
  },
  props: {},
  data() {
    return {
      icons,
      thisSections: null,
      thisObjects: null,
    }
  },
  created() {
    this.setSections( this.post )
    this.setObjects( this.post )
  },
  mounted() {},
  methods: {
    ...mapActions([ 'getModelCollection' ]),
    doAction( action, item ) {
    },
    setSections( post ) {
      if ( !post || !post.sections ) {
        this.thisSections = null
        return
      }
      const sections = []
      for ( const s of post.sections ) {
      }
      // this.thisSections = sections
    },
    setObjects( post ) {
      if ( !post) return
      if ( !post.objects && !post.model ) {
        this.thisObjects = null
        return
      }
      if ( this.post.model ) {
        this.thisObjects = null
        this.getModelCollection({
          model: this.post.model,
          ...( this.post.filter || {} )
        })
      }
    }
  },
  computed: {
    ...mapState([ 'post' ]),
    actions() {
      return ( this.post && this.post.actions ) || []
    },
    sections() {
      return this.thisSections || ( this.post && this.post.sections ) || []
    },
    objects() {
      return  this.thisObjects || ( this.post && this.post.objects ) || []
    },
    title() {
      return ( this.post && this.post.title ) || 'Content'
    }
  },
  watch: {
    post( post ) {
      if ( post ) {
        this.setSections( post )
        this.setObjects( post )
      }
    }
  }
}
</script>

<style lang="scss">
.admin-content {
  section {
    > .header > .title {
      font-size: var(--s-lg);
    }
    > .body {
      > .item.denied {
        padding: var(--s-3q) var(--s-lg);
        --c-fg: grey;
      }
    }
  }
  .main-content {
    overflow: hidden;
  }
}
</style>
